// extracted by mini-css-extract-plugin
export default {"layout":"menu-overlay_layout__WxydP","container":"menu-overlay_container__AcunN"};